<template>
    <div id="mainMenu" class="container v-menu-container tooltip-wrapper" >
        <ul id="v-menu" class="sky-mega-menu sky-mega-menu-anim-scale sky-mega-menu-response-to-icons">
            <!-- <venues></venues> -->
            <!-- <shared-bookings></shared-bookings> -->
            <courses></courses>
            <inventory></inventory>
            <!-- <rooms></rooms> -->
            <customers></customers>
            <reports></reports>
            <settings></settings>

            <!-- BEGIN Actions -->
            <li class="right quick-action" data-toggle="tooltip" data-placement="left" title="Aktionen">
                <a href="#" class="quick-action"><i class="fa fa-link quick-action-fa"></i>
                    <span class="badge badge-new-todos-actions" data-toggle="tooltip" data-placement="right" data-html="true" title="Todos badge text">1</span>
                </a>
                <div class="grid-container3">
                    <ul>
                        <li>
                            <a href="/staff/todos/my/"><i class="fa fa-fw fa-sticky-note-o"></i> Meine TODOs
                                <span class="badge badge-new-todos" data-toggle="tooltip" data-placement="right" data-html="true" title="todo text">1</span>
                            </a>
                        </li>
                        <li><a href="/customers/new/"><i class="fa fa-fw fa-user-plus"></i> Neuer Kunde</a></li>
                        <li><a href="/customers/goodsandservices/i/"><i class="fa fa-fw fa-file-text-o"></i> Rechnung erstellen</a></li>
                        <li><a href="/venues/scheduler/"><i class="fa fa-fw fa-calendar"></i> Kalender</a></li>
                        <li><a href="/venues/timetable/week/"><i class="fa fa-fw fa-clock-o"></i> Freie Zeiten</a></li>
                        <li><a href="/reports/daily-accounting/"><i class="fa fa-fw fa-calculator"></i> Tagesabrechnung</a></li>
                        <li><a href="#" target="_blank"><i class="fa fa-fw fa-server"></i> Buchungswidget</a></li>

                        <li><a href="https://handbuch.venuzle.at" target="_blank"><i class="fa fa-fw fa-lightbulb-o"></i> Online-Handbuch</a></li>
                        <li><a href="/internals/"><i class="fa fa-fw fa-medkit"></i> Venuzle Internals</a></li>
                        <li><a href="/login/account/"><i class="fa fa-fw fa-cog"></i> Mein Account</a></li>
                        <li><a href="/login/end-session/"><i class="fa fa-fw fa-sign-out"></i> Abmelden</a></li>
                    </ul>
                </div>
            </li>
            <!-- END Actions -->

            <!-- Feedback -->
            <li class="right hidden-xs hidden-sm">
                <a href="/venues/scheduler/" style="background-color: #FFFFFF !important;">
                    <img class="vlogo" src="https://manager.venuzle.at/assets/images/v.png" width="22" alt="Venuzle">
                </a>

                <!--            <div class="grid-container3">
                                <ul>
                                    <li><a href="/updates/"><i class="fa fa-bullhorn"></i> Neuigkeiten & Kontakt</a></li>
                                </ul>
                            </div>               -->

            </li>
            <!--/ Feedback -->
        </ul>
    </div>
</template>

<script>
import Venues from '@/components/ManagerMenu/Venues.vue';
import SharedBookings from '@/components/ManagerMenu/SharedBookings.vue';
import Courses from '@/components/ManagerMenu/Courses.vue';
import Inventory from '@/components/ManagerMenu/Inventory.vue';
import Rooms from '@/components/ManagerMenu/Rooms.vue';
import Customers from '@/components/ManagerMenu/Customers.vue';
import Reports from '@/components/ManagerMenu/Reports.vue';
import Settings from '@/components/ManagerMenu/Settings.vue';

export default {
    components: {
        Venues,
        SharedBookings,
        Courses,
        Inventory,
        Rooms,
        Customers,
        Reports,
        Settings,
    },

    created() {
        //
    },

    mounted() {
        //
    },
}
</script>
